import React from 'react';
import {connect} from 'react-redux';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerExclusionSwitcher from 'components/molecules/player-exclusion/player-exclusion-switcher';
import PlayerLock from 'components/molecules/player-lock';
import TeamLogo from 'components/molecules/team-logo';
import FilterLineupsByPlayerAndFlex from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-and-flex';
import PlayerInjury from 'components/molecules/player-injury';
import {getPlayerLineupsQuantityPropName} from 'components/organisms/used-players-list/helpers';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;
        const filteredPlayers = this.getFilteredUsedPlayers();

        let searchParams = {
            ...this.getSearchRuleByPosition(),
        };

        if (filters.position.isKeyFlex() && !filters.isShowUnexposedPlayersEnabled()) {
            searchParams = {
                ...searchParams,
                ...this.getSearchRuleByFlexPosition(),
            };
        }

        let players = filterObjectByParams(filteredPlayers, searchParams, true);
        const sortBy = getPlayerLineupsQuantityPropName(filters.position);

        return sortArrayOfObjects(players, sortBy, 'desc');
    }

    render() {
        const {filters} = this.props;
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tbody key={`${renderKey}${index}`} className={className}>
                        <tr>
                            <td colSpan="5" className="top-line">
                                <PlayerExclusionSwitcher
                                    className="lineups-filter-players-checkbox"
                                    playerId={player.getId()}
                                />
                                <FilterLineupsByPlayerAndFlex player={player} filterPosition={filters.position} />
                                <PlayerLock className={`lock-player lock-btn`} playerId={player.getId()} />
                                <TeamLogo teamName={player.team.toUpperCase()} />
                                <div className="player">
                                    <div>
                                        <span className="pos">{player.positionName.toUpperCase()}</span>
                                        <div className="name">
                                            {player.name}
                                            <PlayerInjury player={player} />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {this.wrapContentInTooltip(
                                    <PlayerPoints
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'userPoints'}
                                    />,
                                    `Default Score: ${player.adminPoints}`,
                                )}
                            </td>
                            <td className="text-blue">
                                <span className="inline-text">{this.calcPlayerExposure(player)}%</span>(
                                {this.calcPlayerLineupsQuantity(player)})
                            </td>
                            <td>
                                <span>{player.projOwn.getValue()}</span>
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMin'}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMax'}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>,
                );
            });
        } else {
            items.push(this.getTBodyPlayersNotFoundView({colSpan: 5}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>ProjOwn</th>
                                <th>Exp.min</th>
                                <th>Exp.max</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{items}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;

    return {
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

const PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
